export default function (state, value) {
    let item = state.filters.filter(i => {
        return i.id === value;
    })[0];
    let index = state.filters.indexOf(item);

    state.filters.splice(index, 1);

    if (!state.filters[0]) {
        state.filter = '';
        return;
    }

    if (state.filter === value) {
        if (index > 0) {
            if (index === state.filters.length) {
                state.filter = state.filters[index - 1].id;
            } else {
                state.filter = state.filters[index].id;
            }
        } else {
            state.filter = state.filters[0].id;
        }
    }
}